export class Result {
    all_scores: string;
    event_id: string;
    in_prize_pool: string;
    flight: string;
    group_event_id: string;
    holes_score: string;
    holes_hcp: string;
    net_skin: string;
    gross_skin: string;
    holes_net_skins: string;
    total_score: string;
    gross_to_par: string;
    gross: string;
    net_to_par: string;
    holes_played: string;
    round_id: string;
    verified: string;
    group_players: string;
    event_status: string;
    status: string;
    start_hole: string;
    start_order: string;
    start_time: string;
    round_name: string;
    position: string;
    order: string;
    front: number[];
    back: number[];
    scoreFront: number;
    scoreBack: number;
    dirty: boolean;
    saving: boolean;
    show_scorecard: boolean;
    rounds_holes_played?: string;
    first: string;
}

